/**
 * @generated SignedSource<<b81212ca69a0ee92ec73325d14feff0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type PackageBillingType = "ONE_TIME" | "SUBSCRIPTION";
import { FragmentRefs } from "relay-runtime";
export type packagePaymentMethodExpired_memberPackage$data = {
  readonly orders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly packageDueDate: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly package: {
    readonly billingType: PackageBillingType;
  };
  readonly squareCard: {
    readonly expMonth: number;
    readonly expYear: number;
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "packagePaymentMethodExpired_memberPackage";
};
export type packagePaymentMethodExpired_memberPackage$key = {
  readonly " $data"?: packagePaymentMethodExpired_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"packagePaymentMethodExpired_memberPackage">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "packagePaymentMethodExpired_memberPackage"
};

(node as any).hash = "5790924ae4eee69a84a1c6c30174a868";

export default node;
